import { FormControl, InputAdornment, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

export const CustomDropDown = ({
  value,
  setValue,
  title,
  data,
  Icon,
  noIcon,
  readOnly,
  label,
  darkLabel,
  noMt,
  noMb,
}) => {
  const [open, setopen] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);

    setopen(false);
  };

  return (
    <FormControl
      fullWidth
      disabled={readOnly}
      sx={{
        mt: noMt ? 0 : 2,
        mb: noMb ? 0 : 2,
        borderRadius: "0px",
        border: "none",
        height: "50px",
      }}
    >
      <Select
        labelId="customer-select-label"
        displayEmpty
        disabled={data?.length === 0 || readOnly}
        value={value}
        onChange={handleChange}
        open={open}
        onClose={() => setopen(false)}
        onOpen={() => setopen(true)}
        MenuProps={{
          onClose: () => setopen(false),
        }}
        InputLabelProps={{
          shrink: false,
        }}
        sx={{
          height: "52.5px",
          borderRadius: "0px",
          border: "1px solid #000",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            borderWidth: "0px",
          },
          "& .MuiSelect-icon": {
            color: "#00000080",
          },
          "& .MuiInputAdornment-root": {
            color: "#00000080",
          },
          fontFamily: "Inter-Regular",
          fontSize: "14px",
          fontWeight: "400",
        }}
        InputP  rops={{
          disableUnderline: true,
          sx: {
            backgroundColor: "transparent",
            fontFamily: "Inter-Regular",
            fontSize: "14px",
            fontWeight: "400",
            borderRadius: "0px",
            "& .MuiInputAdornment-root": {
              color: "#00000080",
            },
          },
        }}
        renderValue={(selected) => {
          if (selected === "" || selected === null) {
            return (
              <em
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  color: darkLabel ? "#000" : "#00000080",
                }}
              >
                {title}
              </em>
            );
          }
          const selectedOption = data.find(
            (option) => option.value === selected
          );
          return selectedOption ? selectedOption.label : selected;
        }}
        startAdornment={
          <>
            {noIcon ? null : (
              <InputAdornment position="start">
                <Icon sx={{ color: "#00000080", fontSize: "20px" }} />
              </InputAdornment>
            )}
          </>
        }
      >
        {title === label && (
          <MenuItem
            style={{
              textTransform: "capitalize",
            }}
            value=""
          >
            None
          </MenuItem>
        )}

        {data?.map((option) => (
          <MenuItem
            style={{
              textTransform: "capitalize",
            }}
            key={option.value}
            value={option.value}
            onClick={option.action}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
